import {useSelector} from "react-redux";
import {State} from "@App/state";

export const useConfig = () => {

    const organization = useSelector((state: State) => state.orders.organization)

    return {
        displayPrices: organization.settings.garage_list.display_prices,
        displayPremiumServices: organization.settings.garage_list.display_premium_services,
        organization
    }
}


